import { createApp } from 'vue'
import App from './App.vue'

import axios from 'axios'
import VueAxios from 'vue-axios'
// import Cookies from 'js-cookie'

import { createWebHistory , createRouter } from 'vue-router'

import LoginView from './views/LoginView.vue'
import MainView from './views/MainView.vue'
import AdminHomeView from './views/admin/HomeView.vue'
import HomeView from './views/HomeView.vue'
import LogoutView from './views/LogoutView.vue'

const routes = [
  { path: '/', component: HomeView},
  { path: '/admin', component: AdminHomeView},
  { path: '/login', component: LoginView },
  { path: '/:id', component: MainView },
  { path: '/logout', component: LogoutView },
]

const router = createRouter({
  history: createWebHistory (),
  routes,
})




// const app = createApp(App).mount('#app')
createApp(App)
.use(VueAxios, axios)
.use(router)
.mount('#app')

 